var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supervisorRightPages"},[_c('div',[_c('supervisor-right-pie')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }